import type { QuestionData } from '@repo/types/questions/Question';
import type { QuestionFillData } from '@repo/types/questions/QuestionFill';
import type { QuestionLongData } from '@repo/types/questions/QuestionLong';
import type { QuestionMatchingData } from '@repo/types/questions/QuestionMatching';
import type { QuestionMultipleData } from '@repo/types/questions/QuestionMultiple';
import type { QuestionSingleData } from '@repo/types/questions/QuestionSingle';
import type { QuestionTranslateData } from '@repo/types/questions/QuestionTranslate';
import type { QuestionVoiceData } from '@repo/types/questions/QuestionVoice';

import { QuestionType } from '@repo/types/enums/questionType';

import {
  QuestionFill as QuestionFillComp,
  QuestionLong as QuestionLongComp,
  QuestionMatching as QuestionMatchingComp,
  QuestionMultiple as QuestionMultipleComp,
  QuestionSingle as QuestionSingleComp,
  QuestionTranslate as QuestionTranslateComp,
  QuestionVoice as QuestionVoiceComp,
} from '@/components/features/quiz/question/question-resolver';

interface QuestionContentTypeProps {
  question: QuestionData;
  questionIndex: number;
  sectionIndex: number;
  showMarked: boolean;
}

export function QuestionContentType(questionContentProps: QuestionContentTypeProps) {
  const { question, sectionIndex, questionIndex, showMarked } = questionContentProps;
  switch (question.type) {
    case QuestionType.SINGLE:
      return <QuestionSingleComp question={question as QuestionSingleData} sectionIndex={sectionIndex} questionIndex={questionIndex} showMarked={showMarked} />;
    case QuestionType.MULTIPLE:
      return <QuestionMultipleComp question={question as QuestionMultipleData} sectionIndex={sectionIndex} questionIndex={questionIndex} showMarked={showMarked} />;
    case QuestionType.FILL:
      return <QuestionFillComp question={question as QuestionFillData} sectionIndex={sectionIndex} questionIndex={questionIndex} showMarked={showMarked} />;
    case QuestionType.MATCHING:
      return <QuestionMatchingComp question={question as QuestionMatchingData} sectionIndex={sectionIndex} questionIndex={questionIndex} showMarked={showMarked} />;
    case QuestionType.TRANSLATE:
      return <QuestionTranslateComp question={question as QuestionTranslateData} sectionIndex={sectionIndex} questionIndex={questionIndex} showMarked={showMarked} />;

    case QuestionType.VOICE:
      return <QuestionVoiceComp question={question as QuestionVoiceData} sectionIndex={sectionIndex} questionIndex={questionIndex} showMarked={showMarked} />;
    case QuestionType.LONG:
      return <QuestionLongComp question={question as QuestionLongData} sectionIndex={sectionIndex} questionIndex={questionIndex} showMarked={showMarked} />;

    default:
      return <p className="text-text-destructive w-full py-14 text-center text-sm">Ten typ pytania nie jest obsługiwany</p>;
  }
}
